module.exports = __webpack_public_path__ + "static/media/Lumada_Logo.a80b2047.svg";